/**
 * Core: Commands (empty)
 * -----------------------------------------------------------------------------
 * Empty file that replaces commands.js when not in production build mode.
 * - This must return the same functions to avoid front-end errors.
 *
 */
/* eslint-disable no-empty-function */

export default () => {
  return Object.freeze({
    cli: () => {
      const warning = () => window.console.warn('Disabled in production build')

      return {
        asyncComponents: warning,
        componentReadyState: warning,
        openOverlay: warning,
        queryCache: warning,
        reset: warning,
      }
    },
    init: () => {},
  })
}
